import { usePutMutation } from "@/api/swr/useMutation";
import { companyUserEditSchema } from "@/schema/console/companies/CompanyUser";
import { z } from "zod";

type Config = Parameters<typeof usePutMutation<typeof companyUserEditSchema, z.ZodUndefined>>[3];

export const useEditCompanyMemberProfile = (
  id: number,
  config?: Config
) => {
  return usePutMutation(
    companyUserEditSchema,
    z.undefined(),
    `/console/company_users/${id}`,
    config,
  );
};
